<template>
  <DialogLayout v-model="localDialog" width="900px" title="Video Clips">
    <v-card>
      <v-card-text>
        <v-row v-if="loading">
          <v-col class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" class="mb-2 pb-0">
            <div>
              <v-card>
                <v-card-text class="px-0 py-0">
                  <div class=" ">
                    <div>
                      <div class="mb-2">
                        <v-col class="d-flex justify-space-between">
                          <v-row class="justify-space-between">
                            <dl class="d-flex">
                              <dt>Zone Name :</dt>
                              <dd class="font-weight-bold ml-1">
                                {{ thumbnail?.zoneName }}
                              </dd>
                            </dl>
                            <dl v-if="thumbnail?.incidentType" class="d-flex">
                              <dt>Incident Type :</dt>
                              <dd class="font-weight-bold ml-1">
                                {{ thumbnail?.incidentType }}
                              </dd>
                            </dl>
                          </v-row>
                        </v-col>
                        <v-col class="d-flex justify-space-between">
                          <v-row class="justify-space-between">
                            <dl class="d-flex">
                              <dt>Incident Started at:</dt>
                              <dd
                                v-if="thumbnail?.startTimestamp"
                                class="font-weight-bold ml-1"
                              >
                                {{ formatTimestamp(thumbnail?.startTimestamp) }}
                              </dd>
                            </dl>

                            <dl class="d-flex" v-if="!noEventsDetected">
                              <dt>Detected on :</dt>
                              <dd class="font-weight-bold ml-1">
                                {{
                                  formatTimestamp(currentThumb?.startTimestamp)
                                }}
                              </dd>
                            </dl>
                            <!-- <dl class="d-flex">
                              <dt>Incident Ended at:</dt>
                              <dd
                                v-if="thumbnail?.endedAt"
                                class="font-weight-bold ml-1"
                              >
                                {{ formatTimestamp(thumbnail?.endedAt) }}
                              </dd>
                              <dd v-else class="font-weight-bold ml-1">NA</dd>
                            </dl> -->
                          </v-row>
                        </v-col>
                        <v-col>
                          <v-row>
                            <dl class="d-flex">
                              <dt>Priority:</dt>
                              <dd class="font-weight-bold ml-1">
                                <SeverityChip
                                  :severity="titleCase(thumbnail?.priority)"
                                />
                              </dd>
                            </dl>
                          </v-row>
                        </v-col>
                        <!-- <v-col >
                          <v-row>
                            <dl class="d-flex">
                              <dt>Person detected on :</dt>
                              <dd class="font-weight-bold ml-1">
                                {{
                                  formatTimestamp(currentThumb?.startTimestamp)
                                }}
                              </dd>
                            </dl>
                          </v-row>
                        </v-col> -->
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Shown only when the incident has both motion and person events -->
              <v-radio-group
                v-if="hasBothEventTypes"
                v-model="selectedEventType"
                row
                hide-details
                class="mt-3 mb-1 ml-1"
              >
                <v-radio
                  label="Motion Detection"
                  value="een.motionDetectionEvent.v1"
                />
                <v-radio
                  label="Person Detection"
                  value="een.personDetectionEvent.v1"
                />
              </v-radio-group>

              <video
                v-if="videoData"
                :key="videoKey"
                controls
                autoplay
                class="video-player"
              >
                <source
                  :src="`data:video/mp4;base64,${videoData}`"
                  type="video/mp4"
                />
              </video>

              <v-img
                v-else-if="currentThumb && currentThumb.thumbnail"
                :src="'data:image/jpeg;base64,' + currentThumb.thumbnail"
                height="500"
                cover
                class="event-thumbnail"
                @click="loadVideo"
              >
                <div class="video-overlay d-flex justify-center align-center">
                  <v-btn
                    icon
                    color="white"
                    class="play-button"
                    @click="loadVideo"
                    :disabled="loadingVideo"
                  >
                    <v-icon large v-if="!loadingVideo"
                      >fas fa-play-circle</v-icon
                    >
                    <v-progress-circular
                      v-else
                      size="30"
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </v-img>

              <div
                v-else
                class="grey lighten-3 d-flex justify-center align-center"
                style="height: 400px"
              >
                <div
                  class="pa-2 position-relative"
                  style="width: 100%; height: 400px"
                >
                  <iframe
                    v-if="noEventsDetected"
                    id="sd_direct_history_iframe"
                    :key="'history-iframe-' + historyIframeKey"
                    width="100%"
                    height="400"
                    :src="directHistoryUrl"
                    allowfullscreen
                    allow="autoplay"
                    style="background-color: #000; width: 100%"
                    @load="setupHistoryIframeListener"
                  ></iframe>

                  <div v-else class="text-center">
                    <v-icon size="64" color="grey">mdi-video-off</v-icon>
                    <p class="mt-4">
                      No event detected during this time period
                    </p>
                  </div>
                </div>
              </div>
              <template v-if="!noEventsDetected">
                <div class="navigation-controls">
                  <v-btn
                    class="navigation-btn prev-btn"
                    :disabled="currentIndex <= 0 || loadingNext"
                    @click="prevThumbnail"
                  >
                    <v-icon left>fas fa-chevron-left</v-icon>
                    Previous
                  </v-btn>

                  <div class="pagination-display">
                    <span class="">{{ currentIndex + 1 }}</span>
                    <span class="">/</span>
                    <span class=" "
                      >{{ thumbnailsCount }}{{ nextPageToken ? "+" : "" }}</span
                    >
                  </div>

                  <v-btn
                    class="navigation-btn next-btn"
                    :disabled="
                      (currentIndex >= thumbnailsList.length - 1 &&
                        !nextPageToken) ||
                      loadingNext
                    "
                    @click="nextThumbnail"
                  >
                    Next
                    <v-progress-circular
                      v-if="loadingNext"
                      indeterminate
                      size="20"
                      color="white"
                      class="ml-2"
                    ></v-progress-circular>
                    <v-icon v-else right>fas fa-chevron-right</v-icon>
                  </v-btn>
                </div>
              </template>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </DialogLayout>
</template>

<script>
import { EEN_VIDEO_FEED, GET_ALL_EEN_EVENTS } from "./graphql";
import { EEN_AUTH_STATUS } from "../fixtures/graphql";
import useFacility from "../authentication/useFacility";
import DialogLayout from "@layout/DialogLayout.vue";
import { titleCase } from "@tod-ui/helpers/strings";
import SeverityChip from "@tod-ui/components/SeverityChip.vue";
import {
  derivePreferredEenEventType,
  PERSON_EVENT_TYPE,
  MOTION_EVENT_TYPE,
} from "./eenEventsHelper";

export default {
  name: "EventVideoDialog",
  components: {
    DialogLayout,
    SeverityChip,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    thumbnail: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const { facilityFormatDateTime4Humans } = useFacility();
    return {
      facilityFormatDateTime4Humans,
    };
  },
  data() {
    return {
      localDialog: false,
      loading: false,
      loadingVideo: false,
      loadingNext: false,
      currentIndex: 0,
      thumbnailsList: [],
      nextPageToken: null,
      videoData: null,
      videoKey: 0,
      pageSize: 10,
      currentThumbnailId: null,
      directHistoryUrl: null,
      noEventsDetected: false,
      iframeLoaded: false,
      iframeAuthSent: false,
      historyIframeKey: 0,
      currentEventType: null,
      allowFallbackToMotion: true,
      hasBothEventTypes: false,
      selectedEventType: null,
    };
  },
  computed: {
    currentThumb() {
      return this.thumbnailsList[this.currentIndex] || null;
    },
    thumbnailsCount() {
      return this.thumbnailsList.length;
    },
  },
  watch: {
    value(newVal) {
      this.localDialog = newVal;
      if (newVal && this.thumbnail) {
        const newThumbnailId = this.getThumbnailId(this.thumbnail);
        if (newThumbnailId !== this.currentThumbnailId) {
          this.reset();
          this.currentThumbnailId = newThumbnailId;
          this.initDialog();
        }
      } else if (!newVal) {
        this.handleDialogClose();
      }
    },
    localDialog(newVal) {
      this.$emit("input", newVal);
      if (!newVal) {
        this.handleDialogClose();
      }
    },
    selectedEventType(newType) {
      if (!newType || !this.hasBothEventTypes) return;
      this.currentEventType = newType;
      this.thumbnailsList = [];
      this.nextPageToken = null;
      this.currentIndex = 0;
      this.videoData = null;
      this.noEventsDetected = false;
      this.loading = true;
      this.loadEventThumbnails().finally(() => {
        this.loading = false;
      });
    },
    thumbnail(newVal) {
      if (newVal && this.localDialog) {
        const newThumbnailId = this.getThumbnailId(newVal);

        if (newThumbnailId !== this.currentThumbnailId) {
          this.reset();
          this.currentThumbnailId = newThumbnailId;
          this.initDialog();
        }
      }
    },
  },
  methods: {
    getThumbnailId(thumb) {
      return `${thumb.actorId}-${thumb.startTimestamp}`;
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return "N/A";
      try {
        if (
          typeof timestamp === "string" &&
          (timestamp.includes("Invalid") || timestamp.includes("undefined"))
        ) {
          return "N/A";
        }
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) {
          return "N/A";
        }
        return this.facilityFormatDateTime4Humans(
          date.toISOString(),
          false,
          true,
          true
        );
      } catch (error) {
        console.error(`Error formatting timestamp (${timestamp}):`, error);
        return "N/A";
      }
    },

    reset() {
      this.currentIndex = 0;
      this.thumbnailsList = [];
      this.nextPageToken = null;
      this.videoData = null;
      this.videoKey = 0;
      this.loadingVideo = false;
      this.loadingNext = false;
      this.currentEventType = null;
      this.allowFallbackToMotion = true;
      this.hasBothEventTypes = false;
      this.selectedEventType = null;
    },

    handleDialogClose() {
      this.reset();
      this.currentThumbnailId = null;

      if (this._messageListenerAdded) {
        window.removeEventListener("message", this.handleHistoryIframeMessage);
        this._messageListenerAdded = false;
      }

      this.$emit("closed");
    },

    async initDialog() {
      if (!this.thumbnail) return;

      this.loading = true;

      try {
        this.thumbnailsList = [];
        this.currentIndex = 0;

        await this.loadEventThumbnails();
      } catch (error) {
        console.error("Error initializing dialog:", error);
      } finally {
        this.loading = false;
      }
    },

    async loadEventThumbnails(pageToken = null) {
      if (!this.thumbnail) return;

      try {
        const actor = this.thumbnail.actorId.includes("camera:")
          ? this.thumbnail.actorId
          : `camera:${this.thumbnail.actorId}`;

        const esn = this.thumbnail.actorId.replace("camera:", "");

        let startTimestamp = this.thumbnail.startTimestamp;
        let endTimestamp = this.thumbnail.endedAt;

        try {
          const startDate = new Date(startTimestamp);
          startTimestamp = startDate.toISOString();

          if (!endTimestamp) {
            endTimestamp = new Date().toISOString();
          } else {
            const endDate = new Date(endTimestamp);
            if (isNaN(endDate.getTime())) {
              endTimestamp = new Date().toISOString();
            } else {
              endTimestamp = endDate.toISOString();
            }
          }

          // if (!endTimestamp) {
          //   endTimestamp = null;
          // } else {
          //   const endDate = new Date(endTimestamp);
          //   endTimestamp = endDate.toISOString();
          // }
        } catch (e) {
          console.error("Error formatting timestamps:", e);
        }
        let results = [];
        let nextPageToken = null;

        const fetchEvents = async (eventType, token = null) => {
          const { data } = await this.$apollo.query({
            query: GET_ALL_EEN_EVENTS,
            variables: {
              organizationId:
                this.thumbnail.organizationId ||
                this.thumbnail.organization.ancestors[0].id,
              actor: actor,
              eventType,
              pageToken: token,
              pageSize: this.pageSize,
              startTimestamp: startTimestamp,
              endTimestamp: endTimestamp,
            },
            fetchPolicy: "network-only",
          });

          return {
            results: data?.eenAllEvents?.results || [],
            nextPageToken: data?.eenAllEvents?.nextPageToken || null,
          };
        };

        if (!pageToken) {
          const incidentEvents = this.thumbnail.events || [];
          const { preferred, allowFallbackToMotion, hasPerson, hasMotion } =
            derivePreferredEenEventType(incidentEvents);
          this.hasBothEventTypes = hasPerson && hasMotion;
          this.allowFallbackToMotion = allowFallbackToMotion;

          if (this.hasBothEventTypes) {
            if (!this.selectedEventType) {
              this.selectedEventType = MOTION_EVENT_TYPE;
            }
            this.currentEventType = this.selectedEventType;
          } else {
            this.currentEventType = preferred || PERSON_EVENT_TYPE;
          }
        }

        const eventTypeToUse = this.currentEventType;
        const secondQueryType =
          eventTypeToUse === PERSON_EVENT_TYPE
            ? MOTION_EVENT_TYPE
            : PERSON_EVENT_TYPE;

        let response = await fetchEvents(eventTypeToUse, pageToken);
        results = response.results;
        nextPageToken = response.nextPageToken;

        if (
          !pageToken &&
          !this.hasBothEventTypes &&
          this.allowFallbackToMotion &&
          results.length === 0
        ) {
          response = await fetchEvents(secondQueryType, null);
          if (response.results.length > 0) {
            results = response.results;
            nextPageToken = response.nextPageToken;
            this.currentEventType = secondQueryType;
          }
        }

        this.nextPageToken = nextPageToken;

        this.directHistoryUrl = `https://iframe.eagleeyenetworks.com/#/history?ids=${esn}&time=${encodeURIComponent(
          startTimestamp
        )}`;

        const enhancedResults = results.map((result) => ({
          ...result,
          organizationId: this.thumbnail.organizationId,
          deviceLocation: this.thumbnail.deviceLocation,
          incidentType: this.thumbnail.incidentType,
        }));
        //const reversedResults = [...enhancedResults].reverse();

        if (pageToken) {
          this.thumbnailsList = [...this.thumbnailsList, ...enhancedResults];
        } else {
          this.thumbnailsList = enhancedResults;
        }

        if (this.thumbnailsList.length === 0) {
          this.noEventsDetected = true;
          this.iframeAuthSent = false;
          this.historyIframeKey++;
          setTimeout(() => this.setupHistoryIframeListener(), 500);
        } else {
          this.noEventsDetected = false;
        }
      } catch (error) {
        console.error("Error loading event thumbnails:", error);

        if (!pageToken && this.thumbnailsList.length === 0) {
          this.thumbnailsList = [this.thumbnail];
        }
      }
    },

    prevThumbnail() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.videoData = null;
      }
    },

    async nextThumbnail() {
      if (this.currentIndex < this.thumbnailsList.length - 1) {
        this.currentIndex++;
        this.videoData = null;
      } else if (this.nextPageToken) {
        this.loadingNext = true;
        try {
          await this.loadEventThumbnails(this.nextPageToken);
          if (this.thumbnailsList.length > this.currentIndex + 1) {
            this.currentIndex++;
            this.videoData = null;
          }
        } finally {
          this.loadingNext = false;
        }
      }
    },

    async loadVideo() {
      if (this.loadingVideo || !this.currentThumb) return;

      this.loadingVideo = true;

      try {
        const { data } = await this.$apollo.query({
          query: EEN_VIDEO_FEED,
          variables: {
            fromTimeStamp: this.currentThumb.startTimestamp,
            deviceId: this.currentThumb.actorId.replace("camera:", ""),
            organizationId:
              this.thumbnail?.organizationId ||
              this.thumbnail?.organization?.ancestors[0].id,
          },
          fetchPolicy: "network-only",
        });

        this.videoData = data?.eenVideoFeed?.video || null;
        this.videoKey++;
      } catch (error) {
        console.error("Error fetching video:", error);
      } finally {
        this.loadingVideo = false;
      }
    },

    setupHistoryIframeListener() {
      const iframe = document.getElementById("sd_direct_history_iframe");
      if (iframe) {
        if (!this._messageListenerAdded) {
          window.addEventListener("message", this.handleHistoryIframeMessage);
          this._messageListenerAdded = true;
        }

        this.sendTokenToHistoryIframe();
      } else {
        setTimeout(() => this.setupHistoryIframeListener(), 200);
      }
    },

    handleHistoryIframeMessage(event) {
      if (event.origin !== "https://iframe.eagleeyenetworks.com") return;

      if (
        event.data === "een-iframe-loaded" ||
        event.data === "een-iframe-token-expired"
      ) {
        this.sendTokenToHistoryIframe();
      }
    },

    async sendTokenToHistoryIframe() {
      const iframe = document.getElementById("sd_direct_history_iframe");

      try {
        if (!this.authToken) {
          const { data } = await this.$apollo.query({
            query: EEN_AUTH_STATUS,
            variables: {
              organization_id:
                this.thumbnail.organizationId ||
                this.thumbnail.organization?.ancestors?.[0]?.id,
            },
            fetchPolicy: "network-only",
          });

          this.authToken = data?.eenAuthStatus?.accessToken;
        }

        if (iframe && iframe.contentWindow && this.authToken) {
          iframe.contentWindow.postMessage(
            {
              type: "een-token",
              token: this.authToken,
            },
            "https://iframe.eagleeyenetworks.com"
          );

          setTimeout(() => {
            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(
                {
                  type: "een-token",
                  token: this.authToken,
                },
                "https://iframe.eagleeyenetworks.com"
              );
            }
          }, 1000);
        }
      } catch (error) {
        console.error("Error sending token to history iframe:", error);
      }
    },
    titleCase,
  },
  mounted() {
    if (!EEN_AUTH_STATUS) {
      import("../fixtures/graphql").then(({ EEN_AUTH_STATUS: authQuery }) => {
        this.EEN_AUTH_STATUS = authQuery;
      });
    }
  },
  beforeDestroy() {
    if (this._messageListenerAdded) {
      window.removeEventListener("message", this.handleHistoryIframeMessage);
    }
  },
};
</script>

<style scoped>
.event-dialog-container {
  height: auto !important;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #000;
}

.event-thumbnail {
  width: 100%;
  height: 100%;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.play-button {
  opacity: 0.9;
  transition: transform 0.2s, opacity 0.2s;
}

.play-button:hover {
  transform: scale(1.2);
  opacity: 1;
}

.navigation-controls {
  /* position: relative; */
  bottom: 10px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
}

.navigation-btn {
  color: white !important;
  font-weight: bold;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 0 20px;
  height: 36px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
}

.prev-btn {
  background-color: #e63946 !important;
}

.next-btn {
  background-color: #2d2e75 !important;
}

/* Hide the original navigation arrows since we're replacing them */
.navigation-arrows {
  display: none;
}

.position-relative {
  overflow: visible; /* Ensure controls can overflow if needed */
  padding-bottom: 30px; /* Extra padding for controls */
}
</style>
